import React from "react";
import ReactDOM from "react-dom/client";
import HistoryHelper from "../helper/history.jsx";
import BookingCalculation from "../lib/booking-calculator.jsx";

import flatpickr from "flatpickr";
import initSpellChecker from "../helper/email-spell-checker.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { Polish } from "flatpickr/dist/l10n/pl.js";
import { Slovak } from "flatpickr/dist/l10n/sk.js";
import { Dutch } from "flatpickr/dist/l10n/nl.js";

window.initFlatpickr = function (overlay) {
  let picker_locale = "default";
  switch (lang) {
    case "de":
      picker_locale = German;
      break;
    case "pl":
      picker_locale = Polish;
      break;
    case "sk":
      picker_locale = Slovak;
      break;
    case "nl":
      picker_locale = Dutch;
      break;
    default:
      picker_locale = "default";
  }

  flatpickr("#booking_dates", {
    locale: picker_locale,
    minDate: $("#booking_dates").data("min-date") || "today",
    mode: "range",
    dateFormat: "d.m.Y",
    allowInput: true,
    static: overlay,
  });

  flatpickr("#search_dates", {
    locale: picker_locale,
    minDate: "today",
    mode: "range",
    dateFormat: "d.m.Y",
    allowInput: true,
    showMonths: 1, //window.handheld ? 1 : 2,
    static: overlay,
  });
};

window.initBookingForm = function () {
  window.initFlatpickr(true);
  window.initFloatingLabels();

  if (
    $("#booking-history").length &&
    $("#booking-history").data("id") != null
  ) {
    var response = HistoryHelper.setBookingItemInfo("booking-history");
    if (response) {
      $("#form_submitter").val(
        window.Translator.trans("booking.again", {}, "js")
      );
    }
  }

  const bookingDates = document.querySelector("#booking_dates");
  if (bookingDates._flatpickr.selectedDates.length < 2) {
    $("#booking_dates").trigger("click");
  }
};

$(document).on("submit", "#contact-form", function (e) {
  e.preventDefault();
  e.stopPropagation();

  const bookingDates = document.querySelector("#booking_dates");
  if (bookingDates._flatpickr.selectedDates.length < 2) {
    $("#booking_dates").trigger("click");
    return false;
  }
  let $submitter = $(this).find("#form_submitter");
  let $loader = $("#form_loader");
  let $form = $("form#contact-form");
  $submitter.prop("disabled", true);
  $submitter.hide();
  $loader.show();

  let post_url = $form.attr("action");
  if (!post_url.startsWith("http")) {
    post_url = base_url + $form.attr("action");
  }

  $.post(post_url, $form.serialize())
    .done(function (data) {
      HistoryHelper.saveBookingData($("#booking").data("id"));
      HistoryHelper.saveVisitedItem($("#booking").data("id"));

      const response = $(data).find("#booking").html();
      $(".mfp-ajax-holder #booking").html(response);

      window.initFlatpickr();
      window.initFloatingLabels();
      initSpellChecker();
    })
    .fail(function (xhr) {
      let magnificPopup = $.magnificPopup.instance;
      magnificPopup.close();
      console.log(xhr);
      let text = window.Translator.trans("booking.fail", {}, "js");
      $submitter.prop("disabled", false);
      $submitter.show();
      $loader.hide();

      alert(text);
    });
});

if ($("#booking_dates").length) {
  initFlatpickr(false);
  HistoryHelper.loadBookingData(".bookingFormTeaser");
}
if ($("#search_dates").length) {
  initFlatpickr(false);
}
if ($(".bookingFormTeaser").length) {
  $(".bookingFormTeaser").on("change", "select, input", function (e) {
    let newUrl = $(".bookingFormTeaser button.submit").data("url");
    newUrl +=
      "?booking_adults=" + $(".bookingFormTeaser #booking_adults").val();
    newUrl +=
      "&booking_children=" + $(".bookingFormTeaser #booking_children").val();
    newUrl += "&booking_dates=" + $(".bookingFormTeaser #booking_dates").val();

    newUrl +=
      "&rental_unit_id=" +
      ($(".bookingFormTeaser #rental_unit_id").val() ?? "");
    $(".bookingFormTeaser").attr("action", newUrl);
    $(".bookingFormTeaser button").attr("href", newUrl);
  });
  HistoryHelper.loadBookingData(".bookingFormTeaser");
  HistoryHelper.setBookingItemInfo();
}

let bcWrap = document.getElementById("booking-calculation");
if (bcWrap !== null) {
  const root = ReactDOM.createRoot(bcWrap);
  root.render(<BookingCalculation bcWrap={bcWrap} />);
}

const dateFormat = window.Translator.trans("locale.date.format", {}, "js");
window.addEventListener("p4g-availability-click", function (e) {
  let clickItem = e.detail;
  let DOMElem = e.target.nextElementSibling;
  if (clickItem.availability > 0 && DOMElem !== null) {
    const { format } = require("date-fns");
    let date = format(new Date(e.detail.date), dateFormat);
    $(".bookingFormTeaser #booking_dates").val(date);
    $(".bookingFormTeaser #booking_dates").trigger("change");
  }
  setTimeout(() => {
    $(DOMElem).find("button").trigger("click");
  }, 200);
});

/**
 * Handle the select elements of #bookingForm
 */
if ($("#bookingForm").length && $("#bookingForm").data("rental_units").length) {
  const rentalUnits = $("#bookingForm").data("rental_units");
  let selectedUnit = rentalUnits.find(
    (unit) => unit.id === $("#rental_unit_id").val()
  );

  /**
   * Generate options for a select element and set its html.
   * @param {number} maxValue maximum value to be chosen from
   * @param {number} selectedValue
   * @param {"adults" | "children"} category
   */
  const generateSelectOptions = (maxValue, selectedValue, category) => {
    let options = "";
    let $node = "";
    let i = 0;

    switch (category) {
      case "children":
        $node = $("#booking_children");
        break;
      default:
      case "adults":
        $node = $("#booking_adults");
        i = 1;
        break;
    }

    for (i; i <= maxValue; i++) {
      options += `<option value="${i}" ${
        i === selectedValue ? "selected" : ""
      }>${window.Translator.transChoice(`booking.fields.${category}.values`, i, { count: i }, "js")}</option>`;
    }

    $node.html(options);
    $node.val(selectedValue);
  };

  $("#rental_unit_id").on("change", function () {
    selectedUnit = rentalUnits.find((unit) => unit.id === $(this).val());
    const adults =
      $("#booking_adults").val() > selectedUnit.capacity_max
        ? selectedUnit.capacity_max
        : $("#booking_adults").val();

    generateSelectOptions(selectedUnit.capacity_max, adults, "adults");
    generateSelectOptions(selectedUnit.capacity_max - adults, 0, "children");
  });

  $("#booking_adults").on("change", function () {
    let restCapacity = selectedUnit.capacity_max - $(this).val();
    generateSelectOptions(
      restCapacity,
      Number($("#booking_children").val()),
      "children"
    );
  });

  $("#booking_children").on("change", function () {
    let restCapacity = selectedUnit.capacity_max - $(this).val();
    generateSelectOptions(
      restCapacity,
      Number($("#booking_adults").val()),
      "adults"
    );
  });
}
